import {IAsset} from '../schema';

export const assetIsVisible = (asset?: IAsset) => {
	return !!asset && asset.visible === 1;
};
